import React, {useState} from "react";
import "./multiInput.scss"

type Props = {
    label: string

    values: string[],
    setValues: (values: string[]) => void
}

export function MultiInput(props: Props): React.JSX.Element {
    return (
        <div className="integrate-input">
            <label>{props.label}</label>
            {
                props.values.map((value, index) => {
                    return <div className={"input-flex"}>
                        <input
                            className="app-input"
                            value={value}
                            onChange={(s) => {
                                const valuesCopy = [...props.values]
                                valuesCopy[index] = s.target.value
                                props.setValues(valuesCopy)
                            }}
                            key={index}
                        />
                        <button onClick={() => {
                            const valuesCopy = [...props.values]
                            valuesCopy.splice(index, 1)
                            props.setValues(valuesCopy)
                        }}>-
                        </button>
                    </div>
                })
            }

            <button onClick={() => props.setValues([...props.values, ""])}>+</button>
        </div>
    )
}